// src/components/auth/IdleLogout.tsx

import { useEffect, useRef } from "react";
import * as authMsal from "../../auth/authMsal"; // 👈 adjust import based on your auth setup
import { useDispatch } from "react-redux";
import { fetchTicketDataError, fetchTicketDataSuccess } from "../../redux/slices/allTicketSlice";
import { setTicketStatusChanged } from "../../redux/slices/ticketStatusSlice";
import { logout } from "../../actions/session";
import { setTheme } from "../../redux/slices/currentThemeSlice";
import { useNavigate } from "react-router-dom";
import { AGENTIC_MS_USER_INFO, AUTHORIZATION_TOKEN, IDLE_TIMEOUT_MS, SESSION_STORAGE_KEY } from "../../constants/appConstants";

interface IdleLogoutProps {
    idleTime?: number; // ms
}

const IdleLogout: React.FC<IdleLogoutProps> = ({ idleTime }) => {
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const resetTimer = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            // 👇 call your msal logout
            //   authMsal.logout(); 
            sessionStorage.removeItem(AGENTIC_MS_USER_INFO);
            sessionStorage.removeItem(AUTHORIZATION_TOKEN);
            sessionStorage.removeItem(SESSION_STORAGE_KEY);
            localStorage.removeItem('cid');
            localStorage.removeItem('sessionId');
            dispatch(logout());
            dispatch(fetchTicketDataSuccess(null));
            dispatch(fetchTicketDataError(null));
            dispatch(setTicketStatusChanged({ ticketStatusChangedOn: '', ticketId: '' }));
            navigate('/')
        }, idleTime);
    };

    useEffect(() => {
        const events = ["mousemove", "keydown", "click", "scroll"];
        events.forEach((event) => window.addEventListener(event, resetTimer));

        resetTimer(); // start countdown on mount

        return () => {
            events.forEach((event) => window.removeEventListener(event, resetTimer));
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, []);

    return null;
};

export default IdleLogout;